import type { SVGProps } from 'react';
const DawnFlagBF = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-BF_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-BF_svg__a)">
      <path fill="#00B051" d="M0 16h22V8.533H0z" />
      <path fill="#FA494B" d="M0 8.533h22V0H0z" />
      <path
        fill="#FDD216"
        d="m11 9.781-1.847 1.341.682-2.203L8.01 7.544l2.269-.02.72-2.19.72 2.19 2.27.02-1.824 1.375.682 2.203z"
      />
    </g>
  </svg>
);
export default DawnFlagBF;
